import { render } from "./DefTitle.vue?vue&type=template&id=64c3ba10&scoped=true"
import script from "./DefTitle.vue?vue&type=script&lang=js"
export * from "./DefTitle.vue?vue&type=script&lang=js"

import "./DefTitle.vue?vue&type=style&index=0&id=64c3ba10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c3ba10"]])

export default __exports__